import React, { useEffect, useState } from "react";

const isDayTime = () => {
    const hour = new Date().getHours();
    return hour >= 12; // entre midi et minuit
};

const Home: React.FC = () => {
    const [isGreen, setIsGreen] = useState(isDayTime());

    useEffect(() => {
        const interval = setInterval(() => {
            setIsGreen(isDayTime());
        }, 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="min-h-screen relative">
            {/* Hero image - plein ecran sur mobile, ratio d'origine conserve a partir de md */}
            <div className="relative w-full overflow-hidden h-screen md:h-auto md:aspect-[1536/1024]">
                <img
                    src="/bg.png"
                    alt="Gas Station"
                    className="absolute inset-0 w-full h-full object-cover"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/30"></div>

                {/* Animated background elements */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute -top-40 -right-40 w-80 h-80 bg-accent/10 rounded-full blur-3xl animate-pulse"></div>
                    <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent/5 rounded-full blur-3xl animate-pulse delay-1000"></div>
                </div>

                {/* Statut + Horaires */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 flex flex-col items-center space-y-3">
                    {/* Badge statut ouvert/ferme */}
                    <div
                        className={`flex items-center space-x-2 bg-black/70 border rounded-full px-4 py-1.5 backdrop-blur-sm ${
                            isGreen
                                ? "border-green-500/40 animate-[pillGlowGreen_2s_ease-in-out_infinite]"
                                : "border-accent/40 animate-[pillGlowRed_2s_ease-in-out_infinite]"
                        }`}
                    >
                        <span
                            className={`w-2 h-2 rounded-full ${isGreen ? "bg-green-500" : "bg-accent"}`}
                        ></span>
                        <span
                            className={`text-sm font-bold tracking-wide ${isGreen ? "text-green-400" : "text-accent"}`}
                        >
                            {isGreen ? "OUVERT" : "FERME"}
                        </span>
                    </div>

                    {/* Horaires */}
                    <div className="flex items-center space-x-2 bg-black/70 border border-accent/30 rounded-full px-5 py-2.5 backdrop-blur-sm animate-[boxGlow_2s_ease-in-out_infinite]">
                        <svg className="w-4 h-4 text-accent flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="text-gray-300 text-base">OUVERT DE 12H00 à 00h00 <span className="text-accent font-semibold">COMMANDES DES MAINTENANT</span></span>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes boxGlow {
                    0%, 100% {
                        box-shadow: 0 0 0 0 rgba(133, 6, 6, 0.5);
                        border-color: rgba(133, 6, 6, 0.3);
                    }
                    50% {
                        box-shadow: 0 0 0 6px rgba(133, 6, 6, 0.15);
                        border-color: rgba(133, 6, 6, 0.8);
                    }
                }
                @keyframes pillGlowGreen {
                    0%, 100% {
                        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.5);
                        border-color: rgba(34, 197, 94, 0.3);
                    }
                    50% {
                        box-shadow: 0 0 0 6px rgba(34, 197, 94, 0.15);
                        border-color: rgba(34, 197, 94, 0.8);
                    }
                }
                @keyframes pillGlowRed {
                    0%, 100% {
                        box-shadow: 0 0 0 0 rgba(133, 6, 6, 0.5);
                        border-color: rgba(133, 6, 6, 0.3);
                    }
                    50% {
                        box-shadow: 0 0 0 6px rgba(133, 6, 6, 0.15);
                        border-color: rgba(133, 6, 6, 0.8);
                    }
                }
            `}</style>
        </div>
    );
};

export default Home;
